var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73123 3.73123C4.03954 3.42292 4.53941 3.42292 4.84772 3.73123L8.5 7.38352L10.3261 5.55737L12.1523 3.73123C12.4606 3.42292 12.9605 3.42292 13.2688 3.73123C13.5771 4.03954 13.5771 4.53941 13.2688 4.84772L9.61648 8.5L13.2688 12.1523C13.5771 12.4606 13.5771 12.9605 13.2688 13.2688C12.9605 13.5771 12.4606 13.5771 12.1523 13.2688L8.5 9.61648L4.84772 13.2688C4.53941 13.5771 4.03954 13.5771 3.73123 13.2688C3.42292 12.9605 3.42292 12.4606 3.73123 12.1523L7.38351 8.5L3.73123 4.84772C3.42292 4.53941 3.42292 4.03954 3.73123 3.73123Z",
    fill: "#FEFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhite);
export default __webpack_public_path__ + "static/media/icon-close-white.9a007abd2a7998d4cc63e691afff98e8.svg";
export { ForwardRef as ReactComponent };